//AddNewCourse

import React, { useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { CircularProgress, Snackbar } from "@material-ui/core";
import ENDPOINT from "../../context/EndPoint";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  Grid,
  Paper,
  Typography,
  TextField,
  MenuItem,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";

const AddNewCourse = () => {
  const { user } = useContext(AuthContext);
  const dispatch = useDispatch();

  const [courseid, setcourseid] = useState("");
  const [ctitle, setctitle] = useState("");
  const [cdescription, setcdescription] = useState("");
  const [cprice, setcprice] = useState("");
  const [cutoff, setcutoff] = useState("");
  const [offerends, setofferends] = useState("");
  const [seatsleft, setseatsleft] = useState("");
  const [nextbatch, setnextbatch] = useState("");
  const [crating, setcrating] = useState("");
  const [cratings, setcratings] = useState("");
  const [cduration, setcduration] = useState("");
  const [courseurl, setcourseurl] = useState("");
  const [promourl, setpromourl] = useState("");
  const [coverfile, setcoverfile] = useState(null);
  const [cstatus, setcstatus] = useState("active");
  const [mode, setmode] = useState("live");

  const [loading, setloading] = useState(false);
  const [snackbar, setsnackbar] = useState(false);
  const [snackbarMessage, setsnackbarMessage] = useState("");

  const addCourse = async (e) => {
    e.preventDefault();
    dispatch({ type: "LOADING" });
    setloading(true);

    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("course_id", courseid);
    formData.append("status", cstatus);
    formData.append("course_title", ctitle);
    formData.append("description", cdescription);
    formData.append("course_price", cprice);
    formData.append("cutoff_price", cutoff);
    formData.append("offer_ends", offerends);
    formData.append("seats_left", seatsleft);
    formData.append("next_batch", nextbatch);
    formData.append("rating", crating);
    formData.append("ratings", cratings);
    formData.append("duration", cduration);
    formData.append("course_url", courseurl);
    formData.append("mode", mode);
    formData.append("promo_url", promourl);
    formData.append("cover_image", coverfile);

    try {
      const res = await axios.post(
        ENDPOINT + "admin-add-course.php",
        formData
      );

      if (res.data.status === "success") {
        setsnackbarMessage("Course Added Successfully");
      } else {
        setsnackbarMessage("Something went wrong");
      }
    } catch (err) {
      setsnackbarMessage("Error: " + err.message);
    }

    setloading(false);
    setsnackbar(true);
    dispatch({ type: "DONE_LOADING" });
  };

  return (
    <Paper elevation={3} sx={{ p: 3, maxWidth: 1100, margin: "32px auto" }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h5">Add New Course</Typography>
        <IconButton onClick={() => window.history.back()}>
          <ArrowBackIcon />
        </IconButton>
      </Box>

      {/* Form */}
      <form onSubmit={addCourse}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <TextField
              label="Course ID"
              fullWidth
              value={courseid}
              onChange={(e) => setcourseid(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label="Status"
              select
              fullWidth
              value={cstatus}
              onChange={(e) => setcstatus(e.target.value)}
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="paused">Paused</MenuItem>
              <MenuItem value="completed">Completed</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Title"
              fullWidth
              value={ctitle}
              onChange={(e) => setctitle(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Description"
              fullWidth
              multiline
              rows={3}
              value={cdescription}
              onChange={(e) => setcdescription(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Course URL"
              fullWidth
              value={courseurl}
              onChange={(e) => setcourseurl(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Promo URL"
              fullWidth
              value={promourl}
              onChange={(e) => setpromourl(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={6}>
  <input
    type="file"
    accept="image/*"
    onChange={(e) => setcoverfile(e.target.files[0])}
  />
</Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Mode"
              select
              fullWidth
              value={mode}
              onChange={(e) => setmode(e.target.value)}
            >
              <MenuItem value="live">Live</MenuItem>
              <MenuItem value="offline">Offline</MenuItem>
              <MenuItem value="selfpaced">Self-paced</MenuItem>
              <MenuItem value="internship">Internship</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label="Price"
              fullWidth
              value={cprice}
              onChange={(e) => setcprice(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label="Cutoff Price"
              fullWidth
              value={cutoff}
              onChange={(e) => setcutoff(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label="Seats Left"
              fullWidth
              value={seatsleft}
              onChange={(e) => setseatsleft(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label="Next Batch"
              type="date"
              fullWidth
              value={nextbatch}
              onChange={(e) => setnextbatch(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label="Offer Ends"
              type="date"
              fullWidth
              value={offerends}
              onChange={(e) => setofferends(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label="Duration"
              fullWidth
              value={cduration}
              onChange={(e) => setcduration(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Rating"
              fullWidth
              value={crating}
              onChange={(e) => setcrating(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Ratings Count"
              fullWidth
              value={cratings}
              onChange={(e) => setcratings(e.target.value)}
            />
          </Grid>
        </Grid>

        <button
          type="submit"
          className="btn btn-primary w-100 mt-4"
          style={{ fontSize: 18, fontWeight: 600 }}
        >
          {loading && <CircularProgress size={20} className="text-white me-2" />}
          Add Course
        </button>
      </form>

      <Snackbar
        open={snackbar}
        autoHideDuration={4000}
        onClose={() => setsnackbar(false)}
        message={snackbarMessage}
      />
    </Paper>
  );
};

export default AddNewCourse;